import { Controller } from "@hotwired/stimulus";
import L from "leaflet";

// Fix Leaflet's default icon path issue
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

// Connects to data-controller="map"
export default class extends Controller {
  static values = {
    polyline: String,
    stops: Array,
    center: Array,
    zoom: Number,
  };

  connect() {
    // Wait for next tick to ensure DOM is ready
    setTimeout(() => {
      this.initializeMap();
      this.renderPolyline();
      this.renderStops();

      // Invalidate size to ensure proper rendering
      if (this.map) {
        this.map.invalidateSize();
      }
    }, 100);
  }

  disconnect() {
    if (this.map) {
      this.map.remove();
      this.map = null;
    }
  }

  initializeMap() {
    const center = this.hasCenterValue ? this.centerValue : [48.7503, 30.2231]; // Uman coordinates
    const zoom = this.hasZoomValue ? this.zoomValue : 13;

    this.map = L.map(this.element).setView(center, zoom);

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      maxZoom: 19,
    }).addTo(this.map);
  }

  renderPolyline() {
    if (!this.hasPolylineValue || !this.polylineValue) {
      return;
    }

    try {
      const coordinates = JSON.parse(this.polylineValue);
      if (coordinates && coordinates.length > 0) {
        const polyline = L.polyline(coordinates, {
          color: "blue",
          weight: 4,
          opacity: 0.7,
        }).addTo(this.map);

        this.map.fitBounds(polyline.getBounds());
      }
    } catch (error) {
      console.error("Error parsing polyline:", error);
    }
  }

  renderStops() {
    if (!this.hasStopsValue || !this.stopsValue.length) {
      return;
    }

    this.stopsValue.forEach((stop) => {
      if (stop.lat && stop.lon) {
        const marker = L.marker([stop.lat, stop.lon]).addTo(this.map);

        if (stop.name) {
          marker.bindPopup(`<strong>${stop.name}</strong>`);
        }
      }
    });
  }
}
